module.exports = __webpack_public_path__ + "a4b306371d67179dbf2bc4beeb18fa8e.jpg";